import { useEffect, useState } from "react";
import { Droppable } from "@hello-pangea/dnd";
import PlusSign from "../../PlusSign/PlusSign";
import BlockDialog from "../../Dialogs/BlockDialog";

export default function AddColumnWithField({
  setIsOpenedDialog,
  uiBlocks,
  setBuildArea,
  buildArea,
  setUiBlocks,
  rowIndex,
  count,
}) {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setIsOpenedDialog(isOpen);
  }, [isOpen, setIsOpenedDialog]);

  return (
    <>
      {isOpen && (
        <BlockDialog
          setOpen={setOpen}
          isOpen={isOpen}
          uiBlocks={uiBlocks}
          setBuildArea={setBuildArea}
          buildArea={buildArea}
          setUiBlocks={setUiBlocks}
          rowIndex={rowIndex}
          count={count}
          fieldToMake={1} // 1 - COLUMN
        />
      )}

      <Droppable
        key={`addColumn-${rowIndex}-${count}`}
        droppableId={`addColumn-${rowIndex}-${count}`}
        direction="vertical"
        type="field"
      >
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className={`plusCol ${snapshot.isDraggingOver ? 'dragging' : ''}`}
            {...provided.droppableProps}
            onClick={() => setOpen(true)}
          >
            <PlusSign />
          </div>
        )}
      </Droppable>
    </>
  );
}

